<template>
    <div class="attachment" v-if="configuration">
        <component :is="configuration.contentType" :key="configuration.id" :id="configuration.id" :configuration="configuration" />
    </div>
</template>

<script>
    export default {
        name: 'Attachment',
        props: {
            configuration: Object
        },
        computed: {

        }
    }
</script>

<style scoped lang="less">

</style>
